export default __webpack_public_path__ + "static/media/MangoGem.9d022738.png";